import { Injectable } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { OfflineQueueService } from "../offline/offline-queue.service";

/**
 * Fachada de la cola de peticiones offline para quien ya la usaba (`app.component`, `tema`). La cola
 * en sí, su tabla y su envío viven en `OfflineQueueService`.
 */
@Injectable({
	providedIn: "root",
})
export class OfflineService {
	constructor(
		private queue: OfflineQueueService,
		private api: ApiService,
	) {}

	/** Empieza a vaciar la cola cada vez que vuelve la conexión (se puede llamar en cada login). */
	async sendPendingOfflineRequests() {
		this.queue.startAutoFlush();
	}

	async saveOfflineTrainingSignatureRequest(canvaImgData, courseID) {
		const body = {
			signature: canvaImgData,
			course_id: courseID,
			is_offline: true,
			created_at: new Date(),
		};
		try {
			await this.queue.enqueue({
				id: `${courseID}_sst`,
				url: this.api.getApiUrls.serviceBaseRest + 'cursos/registro-capacitacion',
				method: 'POST',
				body,
				priority: 1,
				courseId: courseID,
			});
			console.log('registro-capacitacion Datos insertados en SQLite', courseID);
		} catch (error) {
			console.log(`Error al insertar datos en SQLite registro-capacitacion: ${courseID}`, error);
		}
	}

	async saveOfflineCertificateSignatureRequest(canvaImgData, courseID) {
		const body = {
			signature: canvaImgData,
			course_id: courseID,
			// is_offline: true,
			// created_at: new Date(),
		};
		try {
			await this.queue.enqueue({
				id: `${courseID}_cert`,
				url: this.api.getApiUrls.serviceBaseRest + 'cursos/registro-personalizado',
				method: 'POST',
				body,
				priority: 1,
				courseId: courseID,
			});
			console.log('registro-personalizado Datos insertados en SQLite', courseID);
		} catch (error) {
			console.log(`Error al insertar datos en SQLite registro-personalizado: ${courseID}`, error);
		}
	}
}
